export const EDIT_LOCK_CLIENT_SESSION_KEY = 'editLockClientSessionId';
export const EDIT_LOCK_ROUTE_FLAG = 'editLockFlow';
export const EDIT_LOCK_TOKEN_HEADER = 'x-edit-lock-token';
export const EDIT_LOCK_EXPIRED_MESSAGE = 'Submission edit lock has expired';
/** `data.error_type` of a 409 whose lock token no longer exists (e.g. a duplicate tab released the shared token). */
export const EDIT_LOCK_EXPIRED_ERROR_TYPE = 'EDIT_LOCK_EXPIRED';
/** Only these submission statuses can be locked (anything else returns 422). */
export const EDIT_LOCK_LOCKABLE_STATUSES = ['DRAFT', 'INDICATIVE'];
/** Statuses (from view-submission) that never take an edit lock: no acquire call, no x-edit-lock-token header. */
export const EDIT_LOCK_EXEMPT_STATUSES = ['INPROGRESS-HITL', 'UW_REVIEW', 'UW_REQUOTE'];
/** HTTP status returned when the lock is held by someone else, or the token no longer exists (see EDIT_LOCK_EXPIRED_ERROR_TYPE). */
export const EDIT_LOCK_HTTP_STATUS_CONFLICT = 409;
/** HTTP status returned by the heartbeat when the request is rejected as invalid (lock is unusable). */
export const EDIT_LOCK_HTTP_STATUS_BAD_REQUEST = 400;
